"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Icon = _ref => {
  let {
    className,
    name,
    size,
    ...props
  } = _ref;
  const classes = (0, _classnames.default)("arc3-icon", "notranslate", className, {
    ["icon--".concat(size)]: size
  });
  return (
    /*#__PURE__*/
    // have to set font-feature-settings with inline style, because this property gets broken in css file after webpack
    _react.default.createElement("i", _extends({
      className: classes,
      style: {
        fontFeatureSettings: '"liga"'
      }
    }, props), name)
  );
};
exports.Icon = Icon;
Icon.propTypes = {
  /** Custom CSS classes */
  className: _propTypes.default.string,
  /** Valid ARC3 icon name */
  name: _propTypes.default.string,
  /** Icon size */
  size: _propTypes.default.oneOf(["ultra-small", "extra-small", "small", "medium", "large", "extra-large"])
};